var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex text-center justify-content-center align-items-center h-100"},[_vm._v(" チャットを選択して下さい ")])}
var staticRenderFns = []

export { render, staticRenderFns }